export const ROLE_LABEL = {
  USER: "User",
  CARD_ISSUE_OFFICER: "card_issue_officer",
  FRONT_DESK: "front_desk",
  REPORT_VIEWER: "report_viewer",
  CIMS: "cims_platform_administrator",
  SYSTEM: "SYSTEM",
}

export const USER_TYPE = {
  STAFF: { ID: 0, NAME: "Staff" },
  STUDENT: { ID: 1, NAME: "Student" }
}

export const APPLICATION_STAGE = {
  SELECT_REASON: 0,
  SELECT_PAYMENT_METHOD: 1,
  MAKE_PAYMENT: 2,
  COMPLETED: 3,
  OLPP_FAILED: 4,
  OLPP_SUCCEED: 5,
  COMPLETED_CCP: 6
}

export const APPLICATION_CHANNEL = {
  SELF: "SelfServiceForm",
  ADMIN: "AdminDashboard",
}

export const APPLICATION_REASON = {
  LOST: { ID: 0, NAME: "Lost", OPTION_NAME: "My card is lost" },
  DAMAGED: { ID: 1, NAME: "Damaged", OPTION_NAME: "My card is damaged" },
  INTACT: { ID: 2, NAME: "Others", OPTION_NAME: "Other reason" },
}

export const APPLICATION_ADDITIONAL = {
  NONE: { ID: 0, NAME: "Not required" },
  NAME_CHANGED: { ID: 1, NAME: "Amendment of name" },
  PROG_CHANGED: { ID: 2, NAME: "Change of programme mode/level" },
  PHOTO_CHANGED: { ID: 3, NAME: "Change of photo" },
}

export const APPLICATION_PAYMENT_METHOD = {
  OLPP: { ID: 0, NAME: "Online Payment [FPS (Faster Payment System)/ Visa/ MasterCard/ UnionPay]" },
  CCP: { ID: 1, NAME: "Online Payment (Visa/Master/UnionPay)" },
  INPERSON: { ID: 2, NAME: "Cash / Octopus (In-person)" },
  NOPAYMENT: { ID: 3, NAME: "No Payment Needed" },
  TBC: { ID: 99, NAME: "To be confirmed" },
}

export const APPLICATION_STATUS = {
  PENDING: { ID: 0, NAME: "Pending" },
  PAID: { ID: 1, NAME: "Paid" },
  PRINTED: { ID: 2, NAME: "Printed" },
  PENDINGCOLLECT: { ID: 3, NAME: "Waiting for Collection" },
  COLLECTED: { ID: 4, NAME: "Collected" },
  CANCELLED: { ID: 5, NAME: "Cancelled" },
  NOTCANCELLED: { ID: 6, NAME: "Not Cancelled" },
  INOLPPPROGRESS: { ID: 7, NAME: "In Progress" },
}

export const SEARCH_TYPE = {
  SELF: 0,
  ADMIN: 1
}

export const OLPP_PAYMENT_MESSAGE = {
  SUCCEED: "paymentsucceed",
  FAILED: "paymentfailed"
}